
















































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import {
  FormDocumentPlan,
  FormDocumentType,
  ResourceFormPlanType,
  resourceFormPlanTypeMap
} from "@/shared/types";
import { resourceDocumentIcon } from "@/shared/awesomeIconMapper";
import { useCustomerFormDocumentsStore } from "@/employee/store/customerFormDocument";
import DocumentLink from "@/shared/components/ui/DocumentLink.vue";
import DownloadLink from "@/shared/components/ui/DownloadLink.vue";

@Component({
  components: {
    DocumentLink,
    DownloadLink
  }
})
export default class CustomerFormDocuments extends Vue {
  FormDocumentType = FormDocumentType;
  resourceDocumentIcon = resourceDocumentIcon;
  customerFormDocumentStore = useCustomerFormDocumentsStore();
  ResourceFormPlanType = ResourceFormPlanType;
  selectedPlanType: ResourceFormPlanType = ResourceFormPlanType.Unknown;

  @Prop()
  documentType: FormDocumentType;

  mounted () {
    this.customerFormDocumentStore.loadDocuments();
  }

  get documents () {
    if (this.customerFormDocumentStore.isLoaded) {
      if (this.selectedPlanType === ResourceFormPlanType.Unknown) {
        return this.filteredDocuments;
      } else {
        return this.filteredDocuments
          .filter(doc => doc.planTypes.some(x => x.resourceFormPlanType === this.selectedPlanType));
      }
    } else {
      return [];
    }
  }
  get filteredDocuments () {
    return this.customerFormDocumentStore.formDocuments
      .filter(x => x.formDocumentType === this.documentType);
  }
  get availableResourceFormPlanTypes () {
    if (this.customerFormDocumentStore.isLoaded) {
      const hsaFirstSorting = (a: FormDocumentPlan, b: FormDocumentPlan) => {
        const first = ResourceFormPlanType.HealthSavingAccount;
        return a.resourceFormPlanType === first ? -1 : b.resourceFormPlanType === first ? 1 : 0;
      };
      const distinctByPlanType = this.customerFormDocumentStore.availablePlanTypes.filter(
          (plan, i, p) => p.findIndex(t => t.resourceFormPlanType === plan.resourceFormPlanType) === i);
      return distinctByPlanType.sort(hsaFirstSorting);
    } else {
      return [];
    }
  }
  get hasMoreThanOnePlanType (): boolean {
    return this.documents.some(doc => doc.planTypes.length > 1);
  }
  get showPlanTypeFilterPills (): boolean {
    return this.documentType === FormDocumentType.Document
      && this.hasMoreThanOnePlanType;
  }
  planTypeName (pt: FormDocumentPlan) {
    return resourceFormPlanTypeMap[pt.resourceFormPlanType];
  }
  selectPlanType (pt: ResourceFormPlanType) {
    this.selectedPlanType = pt;
  }

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
